





































































    
    import { Component, Vue, Watch } from 'vue-property-decorator';
    import { Popup } from '@questelservices/common-vue';
    import { DxButton, DxTextBox, DxSelectBox, DxLookup } from 'devextreme-vue';
    import { DxValidator, DxEmailRule, DxCustomRule, DxRequiredRule } from 'devextreme-vue/validator';
    import { DxToolbarItem } from 'devextreme-vue/popup';
    import { DxScrollView } from 'devextreme-vue/scroll-view';  
    import { ClientService } from '@/service/ClientService';
    import { SelectOption } from '@/models/SelectOption';
    import { Prop } from 'vue-property-decorator';
    import { confirm, alert } from 'devextreme/ui/dialog';
    import { AgentDto } from '../../models/agent/AgentDto';
    import { AgentService } from '../../service/AgentService';
    import { ClientAgentService } from '../../service/ClientAgentService';
    import { ClientDto } from '../../models/client/ClientDto';    
    import { CountryDto } from '../../models/CountryDto';    
    import { ClientAgentInfoDto } from '../../models/client-agent/ClientAgentInfoDto';
    import DxValidationGroup from 'devextreme-vue/validation-group'
    import ValidationGroup from "devextreme/ui/validation_group";
    import _ from 'lodash';
import { LinkClientAgentDto } from '@/models/client-agent/LinkClientAgentDto';

    @Component({
        components: {
            DxButton,            
            Popup,            
            DxTextBox,            
            DxToolbarItem,
            DxSelectBox,    
            DxLookup,        
            DxValidator,
            DxCustomRule,
            DxScrollView,            
            DxValidationGroup,
            DxRequiredRule
        }
    })
    export default class LinkNewAgent extends Vue {
        public $refs: Vue['$refs'] & {
            validationGroupRef? : ValidationGroup;
        } = {};
        
        @Prop({ default: false })
        showDialog!: boolean;        

        clientAgentService = new ClientAgentService();

        clientsDataSource: SelectOption[] = []; 
        agentsDataSource: SelectOption[] = [];
        
        selectedClientId: Guid = "";
        selectedAgentId: Guid = "";

        get showingDialog() {
            return this.showDialog;
        }

        set showingDialog(value) {
            this.$emit("hiding");
        }

        get clientNotSelected() {
            return this.selectedClientId === "" || this.selectedClientId === null;
        }

        @Watch("showDialog")
        onPropertyChanged(value: boolean, oldValue: boolean) {                
            if (value) {             
               this.selectedClientId = "";
               this.selectedAgentId = "";
               this.validationGroup.reset();
            }            
        }   

        private get validationGroup() {
            return ((this.$refs.validationGroupRef as ValidationGroup).instance as any); 
        }
       
        constructor() {
            super();                           
            this.loadData();       
        }        

        async loadData() {
            let clientService = new ClientService();
            let clients = await clientService.getAll();
            this.clientsDataSource = clients.map(c => {
            return { text: c.ClientName, value: c.ClientId };
            });           
        }       

        async onClientSelected(e: any) {
            if (this.selectedClientId === "" || this.selectedClientId === null) {  
                this.selectedAgentId = ""; 
                this.agentsDataSource = [];      
                return;                 
            }

            let agents = await this.clientAgentService.getUnlinkedAgents(this.selectedClientId);
                console.log(agents.length);
                this.agentsDataSource = agents.map(a => {
                return { text: a.AgentName, value: a.AgentId };
                });   
        }

        hidingCreate() {
            this.showingDialog = false;
        }

        async confirmSave() {
            let validation = this.validationGroup.validate();
            if(!validation.isValid){
                return;
            }

            let clientName = this.clientsDataSource.filter(c => c.value == this.selectedClientId)[0].text;
            let agentName = this.agentsDataSource.filter(a => a.value == this.selectedAgentId)[0].text;

            var result = confirm(`Are you sure you want to link the agent ${agentName} to the client ${clientName}?`, "Link Existing Agent");
            result
                .then(dialogResult => {
                    if(dialogResult) {
                        let linkClientAgentDto: LinkClientAgentDto = {
                            ClientId: this.selectedClientId,
                            AgentId: this.selectedAgentId
                        };

                        this.clientAgentService.linkClientAndAgent(linkClientAgentDto)
                            .then(_ =>{
                                this.hidingCreate();              
                        }); 
                    }
                }
            );                        
        }
    }
